export default {
    institutions: [],
    owners: [],
    schools: []
}